import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { TransferenciaResponseDTO } from '../../models/gerenciar-contas/transferencia.model';
import { TransferenciaDTO, TransferenciaTotaisDTO } from '../../models/gerenciar-contas/transferencia.model';

@Injectable({
  providedIn: 'root',
})
export class TransferenciaService {
  constructor(private apiService: ApiService) { }

  get(url: string, data?: any): Observable<TransferenciaResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<TransferenciaResponseDTO>(path);
  }

  getById<T>(url: string): Observable<TransferenciaDTO> {
    return this.apiService.read<TransferenciaDTO>(url);
  }

  /** Listar transferencias com filtros server-side */
  listarComFiltros(params: { [key: string]: string | number }): Observable<TransferenciaResponseDTO> {
    return this.apiService.readWithParams<TransferenciaResponseDTO>('/movimento/buscar-transferencia', params);
  }

  /** Buscar totais por moeda */
  getTotais(params: { [key: string]: string | number }): Observable<TransferenciaTotaisDTO> {
    return this.apiService.readWithParams<TransferenciaTotaisDTO>('/movimento/total-transferencia', params);
  }

  post<T>(url: string, data: TransferenciaDTO): Observable<TransferenciaDTO> {
    return this.apiService.create<TransferenciaDTO>(url, data);
  }

  put<T>(url: string, data: TransferenciaDTO): Observable<TransferenciaDTO> {
    return this.apiService.update<TransferenciaDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

  buscar(geral: string, page: number, size: number): Observable<TransferenciaResponseDTO> {
    return this.get('/movimento/buscar', {
      geral,
      page,
      size,
      tipoDeTransacao: 'TRANSFERENCIA'
    });
  }
}
